// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__A-zsu","header":"MergedInvoice_header__1eNmW"};